// extracted by mini-css-extract-plugin
module.exports = {"crossIcon":"ClearIcon_crossIcon__mEqqX","crossIcon__1":"ClearIcon_crossIcon__1__saMON","crossIcon__2":"ClearIcon_crossIcon__2__6jm5n"};